module.exports = __webpack_public_path__ + "img/bhutan.2165a86e.svg";